import styled, { css } from 'styled-components';
import type { HeadingLevel } from './types';

const h1Style = css`
  font-size: var(--font-size-display-xs);
  font-weight: var(--font-weight-semibold);
  line-height: 32px;

  @media (width >= 48rem) {
    font-size: var(--font-size-display-md);
    line-height: 44px;
  }
`;

const h2Style = css`
  font-size: var(--font-size-text-lg);
  font-weight: var(--font-weight-semibold);
  line-height: 28px;
`;

const h3Style = css`
  font-size: var(--font-size-text-md);
  font-weight: var(--font-weight-semibold);
  line-height: 24px;
  color: var(--black);
`;

export const H1 = styled.h1<{ $styledAs?: HeadingLevel }>(props => {
  if (props.$styledAs === 3) {
    return h3Style;
  }

  if (props.$styledAs === 2) {
    return h2Style;
  }

  return h1Style;
});

export const H2 = styled.h2<{ $styledAs?: HeadingLevel }>(props => {
  if (props.$styledAs === 3) {
    return h3Style;
  }

  if (props.$styledAs === 1) {
    return h1Style;
  }

  return h2Style;
});

export const H3 = styled.h3<{ $styledAs?: HeadingLevel }>(props => {
  if (props.$styledAs === 2) {
    return h2Style;
  }

  if (props.$styledAs === 1) {
    return h1Style;
  }

  return h3Style;
});
